/* eslint-disable */
// prettier-ignore

export const messages = {
  system_admin_sso_title: "Single Sign-On (SSO) Konfigurationen",
  system_admin_sso_add: "SSO-Konfiguration hinzufügen",
  system_admin_sso_update: "SSO-Konfiguration aktualisieren",
  system_admin_sso_domain: "Domain",
  system_admin_sso_type: "Typ",
  system_admin_sso_provider: "Anbieter",
  system_admin_sso_oauth_config: "OAuth-Konfiguration",
  system_admin_sso_created_successfully: "SSO-Konfiguration erfolgreich erstellt",
  system_admin_sso_updated_successfully: "SSO-Konfiguration erfolgreich aktualisiert",
  system_admin_sso_warning: "Eine <u>Domain</u> kann nur <i><u><b>eine</b></u></i> aktive SSO-Konfiguration gleichzeitig haben. Das Aktivieren einer Konfiguration <i><u><b>deaktiviert</b></u></i> die derzeit aktive.",
  system_admin_sso_do_you_really_want_to_activate_the_sso_config: "Möchten Sie die SSO-Konfiguration wirklich aktivieren?",
  system_admin_sso_do_you_really_want_to_deactivate_the_sso_config: "Möchten Sie die SSO-Konfiguration wirklich deaktivieren?",
  system_admin_sso_login_url: "Login-URL",
  system_admin_sso_client_id: "Client-ID",
  system_admin_sso_client_secret: "Client-Secret",
  system_admin_sso_auth_url: "Autorisierungs-URL",
  system_admin_sso_token_url: "Token-URL",
  system_admin_sso_user_info_url: "Benutzerinfo-URL",
  system_admin_sso_entity_id: "Entity-ID",
};
